<div class="w-[100%] flex justify-end mb-[5px]">
  <div class="flex justify-start">
    <div
      class="ml-[12px] bg-[#f9dacf] px-[6px] pt-[4px] pb-[4px] rounded-[50%] flex justify-end items-center"
    >
      <img
        [src]="
          isHovering1
            ? 'assets/icons/close_hover.svg'
            : 'assets/icons/close.svg'
        "
        alt="close"
        class="cursor-pointer w-[14px]"
        (click)="cancel()"
        (mouseenter)="isHovering1 = true"
        (mouseleave)="isHovering1 = false"
      />
    </div>
    <div class="ml-[12px] bg-[#f9dacf] p-[4px] rounded-[50%]">
      <img
        [src]="
          isHovering2 ? 'assets/icons/save_hover.svg' : 'assets/icons/save.svg'
        "
        alt="save"
        class="cursor-pointer w-[20px] pr-[2px]"
        (click)="save()"
        (mouseenter)="isHovering2 = true"
        (mouseleave)="isHovering2 = false"
      />
    </div>
  </div>
</div>
<div class="autocomplete-container">
  <mat-form-field appearance="outline" class="custom-input">
    <mat-label>Select Stakeholders</mat-label>
    <input
      #inputFieldStakeholder
      matInput
      (keydown)="onKeyDown($event)"
      [formControl]="stakeholderControl"
      (focus)="onFocus()"
      (blur)="onBlur()"
      (keydown.enter)="addStakeholder(inputFieldStakeholder.value)"
    />
  </mat-form-field>
  

  <div class="dropdown" *ngIf="showDropdown">
    <ng-container
      *ngIf="filteredStakeholders | async as stakeholders"
      style="width: 355px"
    >
      <div *ngIf="stakeholders.length > 0">
        <div
          *ngFor="let stakeholder of stakeholders"
          (click)="onSelectionChange(stakeholder)"
          class="dropdown-item"
        >
          {{ stakeholder.name }}
        </div>
      </div>
    </ng-container>
  </div>
  <div class="mt-[25px]">
    <ul>
      <div class="flex" *ngFor="let stakeholder of changeSelectedStakeholders">
        <!-- <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 10 10"
          fill="none"
        >
          <path
            d="M4.61498 8.86234C4.58845 8.86234 4.56221 8.85685 4.53791 8.84621C4.51361 8.83558 4.49177 8.82003 4.47377 8.80055L0.666326 4.68199C0.640945 4.65454 0.624119 4.62027 0.617907 4.5834C0.611695 4.54653 0.616367 4.50865 0.631351 4.47439C0.646336 4.44013 0.670982 4.41099 0.702274 4.39052C0.733566 4.37005 0.770146 4.35915 0.807538 4.35915H2.64023C2.66775 4.35915 2.69494 4.36506 2.71998 4.37647C2.74502 4.38787 2.76732 4.40452 2.78538 4.42528L4.05785 5.88921C4.19536 5.59524 4.46158 5.10578 4.92873 4.50936C5.61935 3.62763 6.90392 2.33088 9.10169 1.16026C9.14417 1.13764 9.19359 1.13177 9.24018 1.14381C9.28678 1.15585 9.32717 1.18492 9.35338 1.22528C9.37958 1.26565 9.3897 1.31437 9.38174 1.36184C9.37377 1.4093 9.3483 1.45205 9.31035 1.48165C9.30196 1.4882 8.45458 2.15551 7.47935 3.3778C6.58181 4.50261 5.38869 6.34184 4.8016 8.71626C4.79128 8.75798 4.76729 8.79504 4.73346 8.82153C4.69963 8.84802 4.65789 8.86241 4.61492 8.86242L4.61498 8.86234Z"
            fill="#1A4971"
          />
        </svg> -->

        <p>
          {{
            stakeholder.stake_holder ? stakeholder.stake_holder : stakeholder
          }}
        </p>

        <button
          type="button"
          class="justify-start"
          (click)="remove(stakeholder)"
          style="margin-top: -0.25rem; margin-left: 0.625rem"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            viewBox="0 0 12 12"
            fill="none"
          >
            <g filter="url(#filter0_d_4054_30471)">
              <ellipse
                cx="5.7573"
                cy="3.99989"
                rx="3.7573"
                ry="3.99989"
                fill="white"
              />
              <path
                d="M9.01461 3.99989C9.01461 5.96276 7.52726 7.49978 5.7573 7.49978C3.98735 7.49978 2.5 5.96276 2.5 3.99989C2.5 2.03702 3.98735 0.5 5.7573 0.5C7.52726 0.5 9.01461 2.03702 9.01461 3.99989Z"
                stroke="#AAD4F5"
                stroke-opacity="0.15"
              />
            </g>
            <path
              d="M4.31152 5.53875L7.20176 2.46191M4.31152 2.46191L7.20176 5.53875"
              stroke="#868E96"
              stroke-width="1.5"
              stroke-linecap="round"
            />
            <defs>
              <filter
                id="filter0_d_4054_30471"
                x="0"
                y="0"
                width="11.5146"
                height="12"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="2" />
                <feGaussianBlur stdDeviation="1" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_4054_30471"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_4054_30471"
                  result="shape"
                />
              </filter>
            </defs>
          </svg>
        </button>
      </div>
    </ul>
  </div>
</div>
